import React from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'
import { colors, fontFamilies } from '../../search-common/settings'
import PropTypes from 'prop-types'
import { translate } from '../../modules/helper-functions'

const Container = styled.div`
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
`

const Title = styled.div`
  font-family: ${fontFamilies.aeonik};
  font-size: 24px;
  font-weight: bold;
  color: ${colors.white};
  margin-bottom: 20px;
`

const P = styled.p`
  font-family: ${fontFamilies.aeonik};
  font-size: 18px;
  color: ${colors.grayTone3};
  margin-bottom: 24px;
`

const Link = styled.a`
  background-color: transparent;
  border: 1px solid ${colors.grayTone3};
  color: ${colors.grayTone3};
  font-size: 14px;
  font-family: ${fontFamilies.aeonik};
  font-weight: bold;
  text-align: center;
  padding: 20px 30px;
  align-self: flex-start;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    color: ${colors.highlight};
    border-color: ${colors.highlight};
  }
`

/**
 *
 */
const CantFindResult = ({ translations, contact_link }) => (
  <Container>
    <Title>{translate( translations, 'Can\'t find what you\'re looking for?' )}</Title>
    <P>{translate( translations, 'Let us know and our real state agent will find a place tailor made for you.' )}</P>
    {contact_link && (
      <Link target="_blank" href={contact_link}>{translate( translations, 'Tell us your needs' )}</Link>
    )}
  </Container>
)

/**
 * Map the redux state to component props.
 *
 * @param {object} state
 * @return {object}
 */
const mapStateToProps = ( state ) => ({
  translations: state.translations,
  contact_link: state.ui.contact_link
})

CantFindResult.propTypes = {
  translations: PropTypes.object.isRequired,
  contact_link: PropTypes.string
}

export default connect( mapStateToProps )( CantFindResult )
